interface ShareBarProps {
  onCopy: () => void;
  copied: boolean;
}

export default function ShareBar({ onCopy, copied }: ShareBarProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-foreground-500">分享到</span>
      <button
        type="button"
        onClick={onCopy}
        className={`flex items-center gap-1 whitespace-nowrap rounded-full px-3.5 py-2 text-xs font-medium transition-colors ${
          copied
            ? "bg-accent-100 text-accent-800"
            : "bg-secondary-100 text-secondary-800 hover:bg-secondary-200"
        }`}
      >
        {copied ? (
          <>
            <i className="ri-check-line text-sm"></i>
            链接已复制
          </>
        ) : (
          <>
            <i className="ri-link text-sm"></i>
            复制链接
          </>
        )}
      </button>
      <a
        href="#copy"
        onClick={(e) => {
          e.preventDefault();
          onCopy();
        }}
        aria-label="复制链接分享"
        className="flex h-8 w-8 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-colors hover:bg-primary-100 hover:text-primary-600"
      >
        <i className="ri-weibo-line" aria-hidden="true"></i>
      </a>
      <a
        href="#copy"
        onClick={(e) => {
          e.preventDefault();
          onCopy();
        }}
        aria-label="复制链接分享到微信"
        className="flex h-8 w-8 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-colors hover:bg-accent-100 hover:text-accent-700"
      >
        <i className="ri-wechat-line" aria-hidden="true"></i>
      </a>
    </div>
  );
}